import './sass/main.scss';
import app from './js/app';
app();
